(function () {
  const body = document.body;
  const drawer = document.querySelector('[data-iwa-drawer]');
  const openMenu = document.querySelector('[data-iwa-menu-open]');
  const closeMenu = document.querySelector('[data-iwa-menu-close]');

  function setDrawer(open) {
    if (!drawer) return;
    drawer.classList.toggle('is-open', open);
    drawer.setAttribute('aria-hidden', String(!open));
    openMenu?.setAttribute('aria-expanded', String(open));
    body.classList.toggle('iwa-drawer-open', open);
  }

  openMenu?.addEventListener('click', () => setDrawer(true));
  closeMenu?.addEventListener('click', () => setDrawer(false));
  drawer?.querySelectorAll('a').forEach((link) => link.addEventListener('click', () => setDrawer(false)));

  const popup = document.querySelector('[data-iwa-popup]');
  if (popup) {
    const delay = Number(popup.dataset.delay || 1800);
    const frequency = popup.dataset.frequency || 'once';
    const storage = frequency === 'always' ? null : frequency === 'session' ? sessionStorage : localStorage;
    const key = 'iwadira-newsletter-popup';
    const signupSucceeded = Boolean(popup.querySelector('[data-iwa-popup-result="success"]'));
    let lastTrigger = null;
    let seen = false;

    try {
      const value = storage?.getItem(key);
      if (frequency === 'days' && value) seen = Date.now() - Number(value) < 7 * 86400000;
      else seen = Boolean(value);
    } catch (error) {
      seen = false;
    }

    const rememberPopup = () => {
      try { storage?.setItem(key, String(Date.now())); } catch (error) { /* Storage can be disabled. */ }
    };

    const openPopup = (trigger) => {
      lastTrigger = trigger || null;
      popup.hidden = false;
      popup.setAttribute('aria-hidden', 'false');
      requestAnimationFrame(() => {
        popup.classList.add('is-open');
        window.setTimeout(() => popup.querySelector('input[type="email"]')?.focus(), 280);
      });
    };

    const closePopup = (remember = true) => {
      popup.classList.remove('is-open');
      popup.setAttribute('aria-hidden', 'true');
      if (remember) rememberPopup();
      window.setTimeout(() => {
        popup.hidden = true;
        lastTrigger?.focus();
      }, 260);
    };

    if (signupSucceeded) {
      rememberPopup();
      popup.hidden = true;
      popup.setAttribute('aria-hidden', 'true');
    } else if (!seen && !Shopify.designMode) {
      window.setTimeout(() => {
        openPopup();
      }, delay);
    }

    document.querySelectorAll('[data-iwa-popup-open]').forEach((trigger) => {
      trigger.addEventListener('click', (event) => {
        event.preventDefault();
        openPopup(trigger);
      });
    });

    popup.querySelector('form')?.addEventListener('submit', rememberPopup);
    popup.querySelector('[data-iwa-popup-close]')?.addEventListener('click', () => closePopup());
    popup.addEventListener('click', (event) => { if (event.target === popup) closePopup(); });
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !popup.hidden) closePopup();
      if (event.key === 'Escape') setDrawer(false);
    });
  }
})();
